<template>
  <div id="newsfeed-items-grid" class="activity-posts-list">
    <SNewSystemMessageActivityPage v-if="allActivities.length <= 0" />
    <div v-for="activity in allActivities" :key="activity.uId">
      <!-- insert index when uncomment ads-->
      <ActivityMyPost
        :item="activity"
        @openWindowPopup="(itemId) => openMsgCenter(itemId)"
        @updateItemStatus="$emit('updateItemStatus')"
        v-if="activity.feedType === 'posts' || activity.status"
      />
      <ActivityRequestPost
        :item="activity"
        @openWindowPopup="openChat(activity.item)"
        @updateItemStatus="$emit('updateItemStatus')"
        v-if="activity.feedType === 'requests' && !activity.status"
      />
    </div>
  </div>
</template>

<script>
import SNewSystemMessageActivityPage from "@/components/organisms/SNewSystemMessageActivityPage";
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import ChatHelperVue from "@/mixins/ChatHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ActivityRequestPost from "@/material-components/molecules/ActivityRequestPost";
import ActivityMyPost from "@/material-components/molecules/ActivityMyPost";
export default {
  name: "ActivityPostsList",
  props: ["activities"],
  components: {
    SNewSystemMessageActivityPage,
    ActivityRequestPost,
    ActivityMyPost,
  },
  mixins: [ChatHelperVue, GroupHelperVue, ItemHelperVue, UserHelperVue],
  data() {
    return {
      selectedKeyChat: {},
    };
  },
  methods: {
    removeStupidAd() {
      let amzAd = document.getElementById("amzn_assoc_ad_div_adunit0_0");
      let list = document.getElementById("app");
      if (list.contains(amzAd)) amzAd.remove();
    },
    openMsgCenter(msgId) {
      this.$router.push({ path: "/s-app/message-center", query: { msgId: msgId }})
    },
    openChat(key) {
      const selectedKeyId = key.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        key.feedType = "NEW_ITEM";
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
        this.selectedKeyChat.messages = this.selectedKeyChat.messages.filter(
          (msg) => {
            return (
              msg.senderId === key.poster.id || msg.receiverId === key.poster.id
            );
          }
        );
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.poster,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
  },
  computed: {
    allActivities() {
      let result = [...this.activities];

      return result;
    },
  },
  mounted() {
    setTimeout(() => {
      this.removeStupidAd();
    }, 3000);
  },
};
</script>

<style scoped>
.activity-posts-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  gap: 24px;
}

</style>
